export default {
    ICC_AGGREGATED_SETTINGS_REFRESH_TIMEOUT: 60,
};
